import { domain } from "../../domain";

export {
    delivery
}

function delivery(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/pos-delivery-company?id=${id}`;
    } else if(name){
        return `${domain}/pos/pos-delivery-company?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/pos-delivery-company?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}
